<template>
  <div class="w-100 h-100 overflow-auto medical-devices-page">
    <d-medical-devices />
  </div>
</template>

<script>

export default {
  name: 'MedicalDevicesPage',
  page: {
    title: 'CRM Doctis - Медицинские приборы',
  },
};
</script>
